<template>
  <el-drawer :withHeader="false" :visible.sync="showDrawer" direction="rtl" :size="drawerSize" :beforeClose="bindSetCancel">
    <div class="drawer_group_wrap">
      <div class="drawer_main_wrap">
        <slot />
      </div>
      <div v-if="drawerButton" class="drawer_foot_wrap">
        <div class="drawer_cancel" @click="bindSetCancel">取消</div>
        <div class="drawer_submit" @click="bindSetSubmit">提交</div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    drawerSize: {
      type: Number,
      default: () => {
        return 500;
      },
    },
    showDrawer: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    drawerButton: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 抽屉-取消按钮
    bindSetCancel() {
      this.$emit('cancel', {});
    },

    // 抽屉-确定按钮
    bindSetSubmit() {
      this.$emit('submit', {});
    },
  },
};
</script>
<style lang="less" scoped>
.drawer_group_wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .drawer_head_wrap {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .drawer_title_wrap {
      position: relative;
      box-sizing: border-box;
      padding-left: 10px;
      font-weight: bold;
      font-size: 16px;
      color: #333;

      &::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 0;
        width: 4px;
        height: 18px;
        background: #43aab7;
        transform: translateY(-50%);
        border-radius: 4px;
      }
    }

    .drawer_close_wrap {
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .el-icon-close {
        font-size: 20px;
        color: #bebebe;
      }
    }
  }

  .drawer_main_wrap {
    flex: 1;
    overflow-y: auto;
  }

  .drawer_foot_wrap {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .drawer_cancel {
      width: 86px;
      height: 32px;
      margin: 0 10px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      font-size: 14px;
      color: #20a2a2;
      background: #fff;
      border: 1px solid #20a2a2;
      border-radius: 4px;

      &:hover {
        color: #20a2a2;
        background: #eaf6f6;
      }
    }

    .drawer_submit {
      width: 86px;
      height: 32px;
      margin: 0 10px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      background: #20a2a2;
      border: 1px solid #20a2a2;
      border-radius: 4px;
    }
  }

  .modal_foot_wrap {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    .modal_sumbit {
      margin-left: 14px;
      color: #fff;
      background: #43aab7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/drawer.vue